export const USER_FORM = {
  userFormContainer: document.querySelector('.aafp_user-form-container') as HTMLElement,
  userUpdate: document.querySelector('#aafp_update-user') as HTMLFormElement,
  userNew: document.querySelector('#aafp_add-new-user') as HTMLFormElement,
  userName: document.querySelector('#aafp_form-user-name') as HTMLInputElement,
  userLastLogin: document.querySelector('#aafp_form-user-last-login') as HTMLInputElement,
  userFirstName: document.querySelector('#aafp_form-user-first-name') as HTMLInputElement,
  userLastName: document.querySelector('#aafp_form-user-last-name') as HTMLInputElement,
  userEmail: document.querySelector('#aafp_form-user-email') as HTMLInputElement,
  userStatus: document.querySelector('#aafp_dropdown-button-status') as HTMLElement,
  userRole: document.querySelector('#aafp_dropdown-button-role') as HTMLElement,
  userPartner: document.querySelector('#aafp_dropdown-button-partner-select') as HTMLElement,
  userAccessContainer: document.querySelector('.aafp_user-form-access-level-container') as HTMLElement,
  userPartnerInput: document.querySelector('.aafp_select-data-container-partner') as HTMLInputElement,
  userPartnerContainer: document.querySelector('.aafp_partner-container') as HTMLElement,
  userPartnerList: document.querySelectorAll<HTMLElement>('[data-partner]'),
  userCustomerFindButton: document.querySelector('#aafp_customer-find') as HTMLElement,
  userCustomerInput: document.querySelector('#aafp_customer-input') as HTMLInputElement,
  userCustomerResults: document.querySelector('.aafp_list-result-container') as HTMLElement,
  userCustomerListContainer: document.querySelector('.aafp_customer-container') as HTMLElement,
  userCustomerList: document.querySelectorAll<HTMLElement>('[data-customer]'),
  userSubmit: document.querySelector('#aafp_user-submit') as HTMLInputElement,
  userID: document.querySelector('#aafp_user-id') as HTMLInputElement,
  userErrorMsg: document.querySelector('.form-error-msg') as HTMLElement
}

export const USER_STATUS = [
  { id: 'Active', name: 'Active' },
  { id: 'Inactive', name: 'Inactive' }
] 

export const USER_ROLES = [
  { id: 'card_group_reporting', name: 'Card Group Reporting' },
  { id: 'customer_reporting', name: 'Customer Reporting' },
  { id: 'customer_admin', name: 'Customer Admin' },
  { id: 'site_reporting', name: 'Site Reporting' },
  { id: 'site_admin', name: 'Site Admin' },
  { id: 'partner_reporting', name: 'Partner Reporting' },
  { id: 'partner_admin', name: 'Partner Admin' },
  { id: 'aag_reporting', name: 'AAG Reporting' },
  { id: 'aag_admin', name: 'AAG Admin' },
  { id: 'pers', name: 'Pers' }
];

export type Roles = 'aag_admin' | 'aag_reporting' | 'site_admin' | 'site_reporting' | 'partner_admin' | 'partner_reporting' | 'customer_admin' | 'customer_reporting' | 'card_group_reporting' | 'pers';

export type AccessType = 'Customer' | 'Partner' | 'Terminal' | 'Card Group';